var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    { attrs: { fluid: "", "pa-0": "" } },
    [
      _c(
        "v-row",
        {
          staticStyle: { height: "100vh" },
          attrs: { align: "center", justify: "center", dense: "" },
        },
        [
          _c(
            "v-col",
            {
              staticClass:
                "fill-height d-flex flex-column justify-center align-center",
              attrs: { cols: "12", lg: "6", md: "6" },
            },
            [
              _c(
                "v-card",
                {
                  staticClass: "mt-n10",
                  attrs: { flat: "", "max-width": "975px" },
                },
                [
                  _c(
                    "v-card-title",
                    [
                      _c(
                        "v-row",
                        { attrs: { align: "center", justify: "center" } },
                        [
                          _c("img", {
                            attrs: {
                              width: "145",
                              height: "50",
                              src: "/content/images/TheStudio_Logo_Lockup-Stacked_Dark.svg",
                            },
                          }),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card",
                    {
                      attrs: {
                        flat: "",
                        "max-width": "400px",
                        "min-width": "350px",
                      },
                    },
                    [
                      !_vm.success && !_vm.invalidKey
                        ? _c(
                            "v-row",
                            { staticClass: "mt-4" },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "ml-8",
                                  attrs: { align: "start" },
                                },
                                [
                                  _c("span", { staticClass: "forgot-lbl" }, [
                                    _vm._v("Forgot your password?"),
                                  ]),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "forgot-desc" }, [
                                    _vm._v(
                                      "We've got your back. We'll email you the instructions to reset your password."
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          )
                        : !_vm.success && _vm.invalidKey
                        ? _c(
                            "v-row",
                            { staticClass: "mt-4" },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "ml-8",
                                  attrs: { align: "start" },
                                },
                                [
                                  _c("span", { staticClass: "forgot-lbl" }, [
                                    _vm._v("Sorry, your key expired!"),
                                  ]),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "forgot-desc" }, [
                                    _vm._v(
                                      "Have no fear, we'll email you another one with instructions to reset your password."
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          )
                        : _c(
                            "v-row",
                            { staticClass: "mt-4" },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "ml-8",
                                  attrs: { align: "start" },
                                },
                                [
                                  _c("span", { staticClass: "forgot-lbl" }, [
                                    _vm._v("Help is on the way!"),
                                  ]),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "forgot-desc" }, [
                                    _vm._v(
                                      "An email has been sent to your inbox with further instructions."
                                    ),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                      _vm._v(" "),
                      _c(
                        "v-row",
                        { attrs: { align: "center", justify: "center" } },
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "toastify-container",
                              attrs: { cols: "10" },
                            },
                            [
                              !_vm.success
                                ? _c(
                                    "form",
                                    {
                                      attrs: { name: "form", role: "form" },
                                      on: {
                                        submit: function ($event) {
                                          $event.preventDefault()
                                          return _vm.requestReset()
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { align: "start" } },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "input-label left",
                                                },
                                                [_vm._v("Enter Your Email")]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-row",
                                        { staticClass: "mt-n6" },
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { align: "center" } },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  id: "email",
                                                  name: "email",
                                                  rules: [
                                                    _vm.rules.required,
                                                    _vm.rules.max,
                                                    _vm.rules.min,
                                                    _vm.rules.email,
                                                  ],
                                                  "hide-details": "auto",
                                                  clearable: "",
                                                  outlined: "",
                                                  dense: "",
                                                  autofocus: "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.$v.resetAccount.email
                                                      .$model,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.$v.resetAccount.email,
                                                      "$model",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "$v.resetAccount.email.$model",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-row",
                                        { staticClass: "mt-4" },
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "6" } },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass:
                                                    "white--text entity-button-text",
                                                  attrs: {
                                                    color: "secondary",
                                                    disabled:
                                                      _vm.$v.resetAccount
                                                        .$invalid,
                                                    type: "submit",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      Send Request\n                    "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "6" } },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass:
                                                    "entity-button-text return-home-btn",
                                                  attrs: {
                                                    text: "",
                                                    color: "secondary",
                                                  },
                                                  on: { click: _vm.openLogin },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    Return to Login\n                  "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.pageHeight > 685
                ? _c(
                    "v-card",
                    { attrs: { flat: "" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { align: "center", justify: "center" } },
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "footer-policy",
                                      style: _vm.isMobile
                                        ? "width: 72%; left:13%"
                                        : "left:9%; width: 31%",
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "footer-policy-txt" },
                                        [
                                          _vm._v(
                                            "Unless otherwise agreed upon in writing, use of this software is subject to the ELB Learning Subscription and "
                                          ),
                                          _c(
                                            "a",
                                            {
                                              staticStyle: { color: "#1D4ED8" },
                                              attrs: {
                                                href: "https://www.elblearning.com/subscription-and-license-agreement",
                                                target: "_blank",
                                              },
                                            },
                                            [_vm._v("License Agreement")]
                                          ),
                                          _vm._v(" and "),
                                          _c(
                                            "a",
                                            {
                                              staticStyle: { color: "#1D4ED8" },
                                              attrs: {
                                                href: "https://www.elblearning.com/privacy-policy",
                                                target: "_blank",
                                              },
                                            },
                                            [_vm._v("Privacy Policy")]
                                          ),
                                          _vm._v("."),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "footer-copy",
                                      style: _vm.isMobile
                                        ? "width: 72%; left:13%"
                                        : "left:9%; width: 31%",
                                      attrs: { align: "center" },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "© " +
                                            _vm._s(_vm.year) +
                                            " ELB Learning. All rights reserved."
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            {
              staticClass:
                "justify-center align-center shrink hidden-sm-and-down",
              staticStyle: { padding: "0px" },
              attrs: { cols: "12", lg: "6", md: "6" },
            },
            [
              _c("v-img", {
                attrs: {
                  height: "100vh",
                  src: "/content/images/LoginScreen_BG-image.webp",
                },
              }),
              _vm._v(" "),
              _c("img", {
                staticClass: "img-logo",
                attrs: { src: "/content/images/ELB-Learning_Logo_White.svg" },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }